(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pf-home-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pf-story-trailer')) {
  customElements.define('pf-story-trailer', class extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('.pf-story__poster');
      if (!trigger || this.dataset.ready) return;
      this.dataset.ready = 'true';
      trigger.addEventListener('click', () => {
        trigger.hidden = true;
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-sample-reader"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(scope){scope.querySelectorAll('[data-pf-reader]').forEach(function(root){
if(root.dataset.ready)return;root.dataset.ready='true';
var pages=Array.from(root.querySelectorAll('[data-reader-page]')),current=0,stage=root.querySelector('.pf-read__stage'),dialog=root.querySelector('dialog'),zoom=dialog.querySelector('img'),lastLink;
root.classList.add('is-enhanced');root.querySelectorAll('[data-reader-controls]').forEach(function(e){e.hidden=false});
function show(n){current=Math.min(pages.length-1,Math.max(0,n));pages.forEach(function(p,i){p.classList.toggle('is-current',i===current)});
root.querySelector('[data-reader-current]').textContent=current+1;
root.querySelectorAll('[data-reader-prev]').forEach(function(b){b.disabled=current===0});
root.querySelectorAll('[data-reader-next]').forEach(function(b){b.textContent=current===pages.length-1?b.dataset.finishLabel:b.dataset.nextLabel;});
}
root.querySelectorAll('[data-reader-prev],[data-reader-next]').forEach(function(b){b.addEventListener('click',function(){if(b.hasAttribute('data-reader-next')&&current===pages.length-1){root.querySelector('[data-reader-ending-title]').focus({preventScroll:true});root.querySelector('.pf-read__close').scrollIntoView({block:'start',behavior:'instant'});return;}show(current+(b.hasAttribute('data-reader-next')?1:-1));stage.scrollIntoView({block:'start',behavior:'instant'});})});
root.querySelectorAll('[data-reader-zoom]').forEach(function(link){link.addEventListener('click',function(e){if(!dialog.showModal)return;e.preventDefault();lastLink=link;zoom.src=link.href;zoom.alt=link.querySelector('img').alt;dialog.showModal();dialog.querySelector('.pf-read__zoom-scroll').scrollTo(0,0);})});
dialog.addEventListener('close',function(){if(lastLink)lastLink.focus({preventScroll:true})});
show(0);
})}
init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-scene-preview"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
root.querySelectorAll('[data-scene-reader]').forEach(function(reader){
if(reader.dataset.ready)return;reader.dataset.ready='true';
var strip=reader.querySelector('.pf-scene__strip'),prev=reader.querySelector('[data-scene-prev]'),next=reader.querySelector('[data-scene-next]'),count=reader.querySelector('[data-scene-current]'),index=0;
function update(){index=Math.round(strip.scrollLeft/strip.clientWidth);count.textContent=index+1;prev.disabled=index===0;next.disabled=index===strip.children.length-1;}
function move(delta){strip.scrollTo({left:Math.max(0,Math.min(strip.children.length-1,index+delta))*strip.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
prev.addEventListener('click',function(){move(-1)});next.addEventListener('click',function(){move(1)});
strip.addEventListener('scroll',update,{passive:true});
strip.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
window.addEventListener('resize',function(){strip.scrollLeft=index*strip.clientWidth;update()});
});
}
init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
